import { useMemo } from "react";
import { useIdRef } from "shared/src/hooks/useIdRef";
import { BackgroundPatternType } from "../types";
import { imagePresets } from "../js/backgroundPresets";

const alignmentMap = {
  left: "cui-left-0",
  right: "cui-right-0",
  inset: "cui-inset-0",
};



export const BackgroundPattern = ({ type, alignment = "inset", size, opacity = 1, blendMode, backgroundSettings, children, image, flip, asBlock, className = "" }: BackgroundPatternType) => {
  const _alignment =
    alignment in alignmentMap ? alignmentMap[alignment] : alignmentMap["inset"];
  const _id = useIdRef({ str: "cui_bg__pat_" }).current;
  const _style = useMemo(() => {
    return {
      width: size?.width ?? 50,
      height: size?.height ?? "100%",
      opacity,
      mixBlendMode: blendMode,
      backgroundImage: `url('${image}')`,
      ...backgroundSettings
    };
  }, [blendMode, opacity, size, image]);

  return (
    <div
      id={_id}
      className={`${!asBlock ? "cui-absolute cui-z-[0]" : ""} ${_alignment} ${flip ? "cui-scale-x-[-1]" : ""} ${className}`}
      style={_style}
    >{children}</div>
  );
};
